module.exports = __webpack_public_path__ + "static/media/productIcon.bc421970.svg";